import React from "react";
import BufferDraggable from "./BufferDraggable";
import { PlanningBufferDraggable } from "../../../../planning/src/components/Header/PlanningBufferDraggable"
import ResultsDraggable from "./Results/ResultsDraggable";
import MeasureDraggable from "./Measure/MeasureDraggable";
import MarkupDraggable from "./Markup/MarkupDraggable";
import LayersDraggable from "./Layers/LayersDraggable";
import PrintDraggable from "./Print/PrintDraggable";
import ParcelDetailsDraggable from "./ParcelDetails/ParcelDetailsDraggable";
import CoordinatesDraggable from "./CoordinatesDraggable";

import { useStore } from "../../stores/store";
import ScaleSettingsDraggable from "./ScaleSettingsDraggable";
import BasemapDraggable from "./BasemapDraggable";
import LegendDraggable from "./LegendDraggable";

export const DraggableRoot = () => {
  const config = useStore((state) => state.config);
  const visibleTools = config?.toolbarOptions.visibleTools;
  const isPlanningApp = config?.isPlanningApp ?? false;

  if (!visibleTools) return null;

  return (
    <>
      {visibleTools["buffer"] && (
        isPlanningApp ? <PlanningBufferDraggable /> : <BufferDraggable />
      )}
      {visibleTools["results"] && <ResultsDraggable />}
      {visibleTools["measure"] && <MeasureDraggable />}
      {visibleTools["layers"] && <LayersDraggable />}
      {visibleTools["print"] && <PrintDraggable />}
      {visibleTools["parcelDetails"] && <ParcelDetailsDraggable />}
      {visibleTools["markup"] && <MarkupDraggable />}
      {visibleTools["basemap"] && <BasemapDraggable />}
      {visibleTools["legend"] && <LegendDraggable />}
      {visibleTools["xy"] && <CoordinatesDraggable />}
      <ScaleSettingsDraggable />
    </>
  );
};
